<template>
  <div class="text-center justify-center">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                depressed
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="laststep()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                paso anterior
              </v-btn>
            </template>
          </v-menu>
          <v-menu
            offset-x
            bottom
            rigth
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mb-4"
                :disabled="invalid"
                v-bind="attrs"
                depressed
                outlined
                v-on="{ ...menu }"
                color="primary"
                @click="nextstep()"
              >
                Siguiente paso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components:{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {};
  },
  methods: {
    laststep() {
      this.$emit("laststep", 3);
    },
    nextstep() {
      this.$emit("nextstep", 5);
    },
  },
};
</script>

<style></style>
